/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, makeStyles } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import {
  GetCourseByUser,
  updateStatusLesson,
} from '../../services/courses';
import { getStatusLessonByUser } from '../../utils';
import ModalWithButton from '../General/TransitionsModal';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: theme.spacing(3, 0, 6, 0),
  },
  buttonBack: {
    background: theme.palette.background.card,
    color: theme.palette.text.default,
    '&:hover': {
      background: theme.palette.background.card,
    },
    fontFamily: 'Raleway',
  },
  buttonFinishLesson: {
    color: theme.palette.background.info,
    border: 'solid 1px',
    borderColor: theme.palette.background.info,
    fontFamily: 'Raleway',
  },
  buttonFinishedLesson: {
    color: theme.palette.text.blue,
    fontFamily: 'Raleway',
    background: theme.palette.background.info,
    '&:hover': {
      background: theme.palette.background.info,
    },
  },
  buttonNext: {
    background: theme.palette.background.secondary,
    color: theme.palette.text.default,
    '&:hover': {
      background: theme.palette.background.secondary,
    },
    fontFamily: 'Raleway',
  },
}));
function Buttons() {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();

  const [isFinishedLesson, setIsFinishedLesson] = useState(false);
  const [isLoadingStateLesson, setIsLoadingStateLesson] = useState(false);

  const [open, setOpen] = useState(false);
  const [indexLesson, setIndexLesson] = useState(0);
  const [lessonByTopic, setLessonByTopic] = useState([]);
  const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  const textBodyModal = '¿Estás seguro que quieres marcar esta lección como finalizada?';

  const updateStatusLessonApi = async () => {
    let infoLesson = {};
    if (location.state.practicalId === undefined && location.state.quizzId === undefined) {
      infoLesson = {
        id: location.state.idLessonUser,
        idTopic: location.state.topic,
        idUser: location.state.idUser,
        idCourse: location.state.course,
        idQuizUser: '',
        idPracticalCaseUser: '',
        idTopicUser: location.state.idTopicUser,
        idFinalProjectUser: location.state.finalProjectUserId,
      };
    }
    if (location.state.practicalId === undefined && location.state.quizzId !== undefined) {
      infoLesson = {
        id: location.state.idLessonUser,
        idTopic: location.state.topic,
        idUser: location.state.idUser,
        idCourse: location.state.course,
        idQuizUser: location.state.quizzId,
        idPracticalCaseUser: '',
        idTopicUser: location.state.idTopicUser,
        idFinalProjectUser: location.state.finalProjectUserId,
      };
    }
    if (location.state.practicalId !== undefined && location.state.quizzId === undefined) {
      infoLesson = {
        id: location.state.idLessonUser,
        idTopic: location.state.topic,
        idUser: location.state.idUser,
        idCourse: location.state.course,
        idQuizUser: '',
        idPracticalCaseUser: location.state.practicalId,
        idTopicUser: location.state.idTopicUser,
        idFinalProjectUser: location.state.finalProjectUserId,
      };
    }
    if (location.state.practicalId !== undefined && location.state.quizzId !== undefined) {
      infoLesson = {
        id: location.state.idLessonUser,
        idTopic: location.state.topic,
        idUser: location.state.idUser,
        idCourse: location.state.course,
        idQuizUser: location.state.quizzId,
        idPracticalCaseUser: location.state.practicalId,
        idTopicUser: location.state.idTopicUser,
        idFinalProjectUser: location.state.finalProjectUserId,
      };
    }
    try {
      setIsLoadingStateLesson(true);
      const response = await updateStatusLesson(infoLesson);
      setIsLoadingStateLesson(false);
      setIsFinishedLesson(true);
      if (response.data === 'Topic evaluations available') {
        const {
          completedLesson, course, finalProjectUserId, idLessonUser, idTopicUser, idUser, lessonId, name, nameCourse, practicalId, quizzId, topic, type,
        } = location.state;
        navigate('/lesson', {
          state: {
            completedLesson,
            course,
            finalProjectUserId,
            idLessonUser,
            idTopicUser,
            idUser,
            lessonId,
            name,
            nameCourse,
            practicalId,
            practicalStatus: true,
            quizzStatus: true,
            quizzId,
            topic,
            type,
          },
        });
      }
      if (response.data.completedTopic === true) {
        navigate('/finished', {
          state: {
            name: nameCourse,
            theme: true,
            course,
          },
        });
      }
    } catch (error) {
      // pending handle error
    }
  };

  const checkIfLessonIsCompleted = async () => {
    setIsLoadingStateLesson(true);
    const isCompletedLesson = await getStatusLessonByUser(location.state.idUser, location.state.course, location.state.topic, location.state.lessonId);
    setIsFinishedLesson(isCompletedLesson);
    setIsLoadingStateLesson(false);
  };

  const checkPositionLesson = async () => {
    const courseByUser = await GetCourseByUser(location.state.idUser, location.state.course);
    const topicSelected = courseByUser.data[0].topicsByUser.filter((e) => e.idTopic === location.state.topic);
    const orderLessons = topicSelected[0].lessonsByUser.sort((a, b) => a.createdAt - b.createdAt);
    const lessonSelected = orderLessons.find((e) => e.idLesson === location.state.lessonId);
    setLessonByTopic(orderLessons);
    setIndexLesson(orderLessons.indexOf(lessonSelected));
  };

  const handleNextLesson = () => {
    navigate('/lesson', {
      state: {
        lessonId: lessonByTopic[indexLesson + 1].idLesson,
        topic: location.state.topic,
        course: location.state.course,
        nameCourse: location.state.nameCourse,
        nameTopic: location.state.nameTopic,
        idLessonUser: lessonByTopic[indexLesson + 1].id,
        completedLesson: location.state.completedLesson,
        idUser: location.state.idUser,
        idTopicUser: location.state.idTopicUser,
        finalProjectUserId: location.state.finalProjectUserId,
        practicalId: location.state.practicalId,
        practicalStatus: location.state.practicalStatus,
        quizzId: location.state.quizzId,
        quizzStatus: location.state.quizzStatus,
      },
    });
  };

  const handleBackLesson = () => {
    navigate('/lesson', {
      state: {
        lessonId: lessonByTopic[indexLesson - 1].idLesson,
        topic: location.state.topic,
        course: location.state.course,
        nameCourse: location.state.nameCourse,
        nameTopic: location.state.nameTopic,
        idLessonUser: lessonByTopic[indexLesson - 1].id,
        completedLesson: location.state.completedLesson,
        idUser: location.state.idUser,
        idTopicUser: location.state.idTopicUser,
        finalProjectUserId: location.state.finalProjectUserId,
        practicalId: location.state.practicalId,
        practicalStatus: location.state.practicalStatus,
        quizzId: location.state.quizzId,
        quizzStatus: location.state.quizzStatus,
      },
    });
  };
  const stylesIcon = (e) => (<InfoOutlined className={e} />);

  useEffect(() => {
    checkPositionLesson();
    checkIfLessonIsCompleted();
  }, [location.state.lessonId]);

  return (
    <div>
      <Box className={classes.container}>
        { indexLesson === 0 ? null : <Button variant="contained" startIcon={<ArrowBackIosIcon />} className={classes.buttonBack} onClick={() => handleBackLesson()}>Leccion pasada</Button>}
        { isLoadingStateLesson ? <Button variant="outlined" className={classes.buttonFinishLesson}> Cargando...</Button>
          : isFinishedLesson
            ? <Button variant="outlined" className={classes.buttonFinishedLesson}>Lección finalizada</Button>
            : <Button variant="outlined" className={classes.buttonFinishLesson} onClick={() => handleOpenModal()}>Finalizar lección</Button>}
        { indexLesson < lessonByTopic.length - 1 ? <Button variant="contained" endIcon={<ArrowForwardIosIcon />} className={classes.buttonNext} onClick={() => handleNextLesson()}>Siguiente lección</Button> : null}
      </Box>
      <ModalWithButton open={open} textBody={textBodyModal} textButton="FINALIZAR" actionButton={updateStatusLessonApi} handleClose={handleCloseModal} icon={stylesIcon} />
    </div>
  );
}

export default Buttons;
